import { MDCSelect } from '@material/select';
import {MDCSnackbar} from '@material/snackbar';
import {MDCDialog} from '@material/dialog';
// import {MDCTooltip} from '@material/tooltip';
// const tooltip = new MDCTooltip(document.querySelector('.mdc-tooltip'));
const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));

const dialog = new MDCDialog(document.querySelector('.mdc-dialog'));
const cart_badge = document.querySelector('.cart-badge');
const selects = document.querySelectorAll('.mdc-select');
const mdcSelects = []
selects.forEach(m => {
  const s = new MDCSelect(m);
  mdcSelects.push({ id: m.dataset.param + "_" + m.dataset.pid, select: s, param: m.dataset.param, pid: m.dataset.pid, selectname: m.dataset.selectname })
  s.listen('MDCSelect:change', (e) => {
    if (m.dataset && m.dataset.ctl === "getProductItem") {
      let scroll_status = true
      if (s.foundation.adapter.hasClass('mdc-select-notice')) {
        scroll_status = false
      }
      getProductItem({ ctl: m.dataset.ctl, value: s.value, param: m.dataset.param, pid: m.dataset.pid, scroll: scroll_status })
      s.foundation.adapter.removeClass('mdc-select-notice')
    }
  })
})

const buttons = document.querySelectorAll('.mdc-button, .btn, .button');
buttons.forEach(b => {
  b.disabled = false
  b.addEventListener('click', function() {
    const pid = b.dataset.pid
    const ctl = b.dataset.ctl
    if (ctl === "FavoriteStatus") {
      FavoriteStatus(pid)
    } else if (ctl === "goToAncor") {
      const ancor = document.querySelector('#' + pid);
      ancor.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    } else if (ctl === "AddToCartItem") {
      const text_params = []
      mdcSelects.forEach(s => {
        if (s.select.value !== "") {
          s.select.foundation.adapter.removeClass('mdc-select-notice')
        } else {
          text_params.push(s.selectname)
          s.select.foundation.adapter.addClass('mdc-select-notice')
        }
      })
      if (text_params.length > 0) {
        openDialogWithParamText({ text : "Wybierz " + text_params.join(" ")})
      } else {
        AddToCart(b.dataset.stock_id)
        // console.log(b.dataset.stock_id)
      }
    } else if (ctl === "openDialogWithParamImages") {
      openDialogWithParamImages(b.dataset.param)
    } else {
      if (ctl === "getProductItem" || ctl === "getFullTable") {
        mdcSelects.forEach((item, i) => {
          item.select.selectedIndex = -1
        });
        getProductTable({ pid: pid })
      }
    }
  })
})

function getProductTable(params) {
  fetch('/pl/pt/' + params.pid, {
    method: 'get',
    credentials: 'include',
  })
  .then(resp => {
    resp.text().then(c => {
      const o = JSON.parse(c);
      const table = document.querySelector('#itemrow_' + params.pid);
      table.innerHTML = o.html
      table.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
      activateAddToCartButtons()
    })
  })
}

function openDialogWithParamImages(params) {
  const dialog_content = document.querySelector('#DialogContent')
  dialog_content.innerHTML = '';
  const images = params.split(',')
  images.forEach(i => {
    let img = document.createElement("img")
    img.src = 'https://hurtownia.anstel.pl/images/tabele/' + i
    let br = document.createElement("br")
    dialog_content.append(img)
    dialog_content.append(br)
    // dialog_content.append('<img src="' + 'https://hurtownia.anstel.pl/images/tabele/' + i + '" />');
  })
  dialog.open()
}

function openDialogWithParamText(params) {
  const dialog_content = document.querySelector('#DialogContent')
  dialog_content.innerHTML = params.text;
  dialog.open()
}

export const ActivateAddToCartButtons = (pid) => {
  activateAddToCartButtons();
}

function activateAddToCartButtons() {
  const buttons = document.querySelectorAll('.btn, .mdc-button, .button');
  buttons.forEach(b => {
    b.addEventListener('click', function() {
        const pid = b.dataset.pid
        const ctl = b.dataset.ctl
        if (ctl === "AddToCart") {
          AddToCart(pid)
        }
        if (ctl === "AddToCartItems") {
          AddToCartItems(pid)
        }
      })
  })
  const pattern_buttons = document.querySelectorAll('.pattern-cell');
  pattern_buttons.forEach(b => {
    b.addEventListener('click', function() {
      const dialog_content = document.querySelector('#DialogContent')
      dialog_content.innerHTML = '';
      dialog_content.innerHTML = '<img src="' + b.dataset.img + '" />';
      dialog.open()
    })
  })
}

function getProductItem(params) {
  const select_color = mdcSelects.filter(i => {
    return i.id === 'color_' + params.pid
  })
  const select_size = mdcSelects.filter(i => {
    return i.id === 'size_' + params.pid
  })
  const select_pattern = mdcSelects.filter(i => {
    return i.id === 'pattern_' + params.pid
  })

  let select_size_value = select_size[0].select.value
  if (select_size_value === "") {
    select_size_value = 0
  }

  let select_color_value = select_color[0].select.value
  if (select_color_value === "") {
    select_color_value = 0
  }

  let select_pattern_value = 0
  if (select_pattern[0]) {
    select_pattern_value = select_pattern[0].select.value
    if (select_pattern_value === "") {
      select_pattern_value = 0
    }
  }

  fetch('/pl/pi/' + params.pid + '|' + select_color_value + '|' + select_size_value + '|' + select_pattern_value, {
    method: 'get',
    credentials: 'include',
  })
  .then(resp => {
    resp.text().then(c => {
      const o = JSON.parse(c);
      if (o.pid !== 0) {
        const b = document.querySelector('#AddToCartItem')
        b.dataset.stock_id = o.pid
      }
      const table = document.querySelector('#itemrow_' + params.pid);
      table.innerHTML = o.html
      if (params.scroll) {
        table.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
      }
      activateAddToCartButtons()
    })
  })
}

export const AddToCartItems = (pid) => {
  const product_table = document.querySelector('#itemrow_' + pid);
  const product_inputs = product_table.querySelectorAll('input');
  const items_to_cart = []
  product_inputs.forEach(i => {
    if (i.value !== "") {
      const qty = parseInt(i.value)
      items_to_cart.push({ pid: i.dataset.pid, qty: qty })
    }
  })

  fetch('/cartitems', {
    method: 'POST',
    credentials: 'include',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      "items": items_to_cart,
    })
  })
  .then(result => {
    const p = Promise.resolve(result.json());
    p.then(v => {
      if (v.result > 0) {
        // snackbar.open()
        // snackbar.labelText = v.title
        // snackbar.timeoutMs = 7000
        if (v.total_count) {
          cart_badge.style.visibility = "visible";
          cart_badge.innerHTML = (parseInt(cart_badge.textContent) + parseInt(v.total_count));
        }
        openDialogWithParamText({ text : v.title})
        if (v.warn_items && v.warn_items.length > 0) {
          v.warn_items.forEach(i => {
            document.querySelector('#itemtablerow-' + i.product).classList.add("qty-warn");
            document.querySelector('#itemqty-' + i.product).value = i.qty
          })
        }
        if (v.new_items && v.new_items.length > 0) {
          v.new_items.forEach(i => {
            document.querySelector('#itemqty-' + i).value = ''
            document.querySelector('#itemtablerow-' + i).classList.remove("qty-warn");
          })
        }
      }
    });
  })
  .catch(err => {console.log(err)
  });
}

export const AddToCart = (pid) => {
  const quantity_inp = document.querySelector('#itemqty-' + pid);
  const quantity = {};

  if (!quantity_inp) {
    openDialogWithParamText({ text : "Przepraszamy, brak rozmiaru i koloru. " })
    return
  }

  if (quantity_inp.value == "") {
    quantity.value = 1;
  } else {
    quantity.value = quantity_inp.value
  }

  fetch('/cart', {
    method: 'POST',
    credentials: 'include',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      "productId": pid,
      "quantity": parseInt(quantity.value),
      "promo": 0
    })
  })
  .then(result => {
    const p = Promise.resolve(result.json());
    p.then(v => {
      if (v.result === 1) {
       cart_badge.style.visibility = "visible";
       cart_badge.innerHTML = (parseInt(cart_badge.textContent) + parseInt(quantity.value));
       LoadCartItems()
       openDropdownCart()
       quantity_inp.value = ''
       document.querySelector('#itemtablerow-' + pid).classList.remove("qty-warn");
      }
      if (v.result === 0) {
        openDialogWithParamText({ text : v.message })
        document.querySelector('#itemtablerow-' + pid).classList.add("qty-warn");
        document.querySelector('#itemqty-' + pid).value = v.qty
        // snackbar.open()
        // snackbar.labelText = v.message
        // snackbar.timeoutMs = 5000
      }

    });
  })
  .catch(err => {console.log(err)
  });
}

export const FavoriteStatus = (pid) => {
  fetch('/favorite/status/' + pid)
  .then(result => {
    const p = Promise.resolve(result.json());
    p.then(v => {
      snackbar.open()
      snackbar.labelText = v.status_message
      const element = document.querySelector('#fav-' + pid)
      if (element) {
        element.textContent = v.status_icon
      }
    })
  })
}
